import React, { useEffect, useState } from "react";
import axios from "axios";
import Table from "../ErrorTab/Table";
import Filtering from "../RuleCatalogue/Filtering";
import heartLoading from "../../assests/heartLoading.gif";

const ErrorDetails = ({
  productId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [columnFilters, setColumnFilters] = useState({});

  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  const handleColumnFiltersChange = (filters) => {
    setColumnFilters(filters);
  };

  const buildQueryString = () => {
    let query = [];

    query.push(`product_id=${productId}`);
    query.push(`page=${page}`);
    query.push(`page_size=${pageSize}`);

if (searchTerm && searchTerm.trim() !== "") {
  query.push(`search_term=${searchTerm}`);
}

    Object.entries(currentFilters).forEach(([key, value]) => {
      if (!value) return;

      const mappedKey = capitalize(key);

      if (Array.isArray(value)) {
        value.forEach((v) =>
          query.push(`filter=${mappedKey}=${v}`)
        );
      } else {
        query.push(`filter=${mappedKey}=${value}`);
      }
    });

    Object.entries(columnFilters).forEach(([key, value]) => {
      if (!value) return;
      query.push(`column_search=${key}=${value}`);
    });

    return query.join("&");
  };

  useEffect(() => {
    if (!productId) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const qs = buildQueryString();
        const url = `${BASE_URL}/error-details-results?${qs}`;

        const response = await axios.get(url);
        setData(response.data);
      } catch (err) {
        console.error("Error fetching error details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    currentFilters,
    searchTerm,
    page,
    productId,
    columnFilters,
    BASE_URL,
  ]);

  const handlePageChange = (p) => {
    setLoading(true);
    setPage(p);
  };

  if (!data) {
    return (
      <div className="relative bg-white flex items-center justify-center z-50 min-h-screen">
        <div className="flex flex-col items-center space-y-3">
          <img src={heartLoading} alt="Loading..." style={{ width : 200}}/>
          <span className="text-gray-700 text-[20px] text-center">
            Hang tight! The resources are loading...
          </span>
        </div>
      </div>
    );
  }


  return (
    <div className="error-detailss">
      <Filtering
        productId={productId}
        availableFilters={data.filters}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
      />

      <Table
        tableData={data.tableData}
        pagination={data.pagination}
        onPageChange={handlePageChange}
        errorPreviews={data.errorPreviews}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        loading={loading}
        onColumnFiltersChange={handleColumnFiltersChange}
      />
    </div>
  );
};

export default ErrorDetails;
